import { Injectable } from '@angular/core';
import { defineFont } from '@progress/kendo-drawing/pdf';

@Injectable({
  providedIn: 'root',
})
export class FontRegisterService {
  private fontsRegistered = false;

  registerFonts(): void {
    if (this.fontsRegistered) return;

    defineFont({
      Roboto: 'assets/fonts/Roboto-Regular.ttf',
    });

    defineFont({
      'Roboto|Bold': 'assets/fonts/Roboto-Bold.ttf',
    });

    this.fontsRegistered = true;
  }
}
